
import { lang, activeList, g_listOrigin } from "../core/variables-global.js";
import { labelList, paginationLabel, headingFieldsLabel, headingFieldsLabel_es, headingFieldsLabel_custom, screenReaderText, filtresLabels } from "../core/l10n.js";
import helpers from "../utils/helpers.js";
import UIHelper from "../utils/UIHelper.js";
import validationForm from "../utils/validation.js";
import a11y from "../modules/a11y.js";

function tableauResultats() {
  // Constantes pour les sélecteurs
  const SELECTORS = {
    RESULTS_CONTAINER: ".js-module-resultats-recherche",
    THERMOPOMPE_HE: ".js-thermopompe-he",
    BUTTON_FILTRES: ".js-button-filtres",
    BUTTON_RESET: ".js-button-reset",
    MODELE_EXTERNE: ".js-modele_externe",
    MODELE_INTERNE: ".js-modele_interne",
    FOURNAISE: ".js-fournaise",
    PUISSANCE_NOMINALE_MIN: ".js-puissance_nominale_min",
    PUISSANCE_NOMINALE_MAX: ".js-puissance_nominale_max",
    PUISSANCE_MOINS_8_MIN: ".js-puissance_moins_8_min",
    PUISSANCE_MOINS_8_MAX: ".js-puissance_moins_8_max",
    AIDE_FINANCIERE_MIN: ".js-aide_financiere_min",
    AIDE_FINANCIERE_MAX: ".js-aide_financiere_max",
    CHECKBOX_THERMOPOMPE_HE: ".js-checkbox-thermopompe-he",
    CHECKBOX_PUISSANCE_NOMINALE: ".js-checkbox_puissance_nominale",
    CHECKBOX_PUISSANCE_MOINS_8: ".js-checkbox_puissance_moins_8",
    CHECKBOX_ADMISSIBLE_BONIFICATION: ".js-checkbox_admissible_bonification",
    LOADING_INDICATOR: ".js-loading_table",
    WALL_OF_ERRORS: ".js-wall-of-errors",
    MARQUES_CONTAINER: ".js-selection-marques",
  };

  //let formIsValid; // État de validation du formulaire
  let showListItems = 10; // Nombre d'items à afficher par page (réduit pour la pagination)
  const paginationOptions = [10, 50, 100]; // Options de pagination disponibles
  let listErrors = []; // Liste des champs avec erreurs


  let paginationState = {
    currentPage: 1
  }; // État de la pagination

  /*************/
  // État du tri
  let sortState = {
    /*field: "marque",
    direction: "asc"*/
  };
/********************/


  // Fonctions d'accessibilité déplacées vers modules/a11y.js (alias conservés pour compatibilité)
  const announceToScreenReader = a11y.announce;
  const createLiveRegion = a11y.createLiveRegion;

  // Détermine les colonnes qui doivent être affichées pour chaque type de liste (HTML ET CSV)
  const headingFieldsList = {
    "proprio-maison": {
      "neep": ["ahri", "marque", "modele_exterieur", "modele_interieur","fournaise", "haut_rendement", "puissance_nominale", "puissance_moins_8", "aide_financiere_a", ""],
      "es": ["pd_id",	"ahri_reference_number", "outdoor_unit_brand_name", "model_number",	"indoor_unit_model_number",	"furnace_model_number", "cooling_capacity_btu_h",	"heating_capacity_at_17_f_btu_h",	"cold_climate", "TTG_AF_EffAlone", "TTG_colBonification"]
    },
      "entrepreneur-maison": {
        "neep": ["ahri", "marque", "modele_exterieur", "modele_interieur", "fournaise","puissance_nominale", "puissance_moins_8", "aide_financiere_a", "", ""],
        "es": ["pd_id",	"ahri_reference_number", "outdoor_unit_brand_name", "model_number",	"indoor_unit_model_number",	"furnace_model_number", "cooling_capacity_btu_h",	"heating_capacity_at_17_f_btu_h",	"", "TTG_AF_Maison1"]
      },
    "proprio-calfeutrage": {
      "neep": ["ahri", "marque", "modele_exterieur", "modele_interieur", "fournaise","puissance_nominale", "puissance_moins_8", "aide_financiere_a", "", ""]
    },
    "entrepreneur-plex": {
      "neep": ["ahri", "marque", "modele_exterieur", "modele_interieur", "fournaise","puissance_nominale", "puissance_moins_8", "aide_financiere_a", "aide_financiere_b",""],
      "es": ["pd_id",	"ahri_reference_number", "outdoor_unit_brand_name", "model_number",	"indoor_unit_model_number",	"furnace_model_number", "cooling_capacity_btu_h",	"heating_capacity_at_17_f_btu_h",	"", "TTG_AF_Multi1", "TTG_AF_Multi4"]
    },
    "office-habitation": {
      "neep": null,
      "es": ["pd_id",	"ahri_reference_number", "outdoor_unit_brand_name", "model_number",	"indoor_unit_model_number",	"furnace_model_number", "cooling_capacity_btu_h",	"heating_capacity_at_17_f_btu_h"]
    },
    "menages-revenu-modeste": {
      "neep": null,
      "es": ["pd_id",	"ahri_reference_number", "outdoor_unit_brand_name", "model_number",	"indoor_unit_model_number",	"furnace_model_number", "cooling_capacity_btu_h"]
    }
  };


  /**
   * Initializes the data loading process and sets up event listeners.
    *
    * This function attempts to register an event listener for the 'dataReady' event
   * on the IndexedDBManager object. When data is fully loaded and ready in IndexedDB,
   * it processes the dataset and updates the UI.
   * If IndexedDBManager is not available, it retries initialization after a 100ms delay.
   *
   * @function init
   * @throws {Error} Logs any errors that occur during the initialization process
   *
   * @example
   * // Initialize the data loader
   * init();
   *
   * @since 1.0.0
   */
  const init = () => {
    try {
      // Écouter l'événement dataReady de IndexedDBManager pour s'assurer que les données sont complètement chargées
      if (window.IndexedDBManager) {
        window.IndexedDBManager.addEventListener("dataReady", (eventData) => {
          console.log("Données prêtes dans IndexedDB pour le dataset:", eventData);

          // Ne pas afficher si les données sont vides suite à une erreur
          if (eventData.source === "error") {
            console.warn("Données non disponibles suite à une erreur");
            showLoading(false);
            pendingSearch = false;
            return;
          }

          displayHE(activeList.name);

          // Initialiser la région live pour les annonces
          createLiveRegion();

          // Si une recherche était en attente, l'exécuter maintenant
          if (pendingSearch) {
            console.log("Exécution de la recherche en attente...");
            pendingSearch = false;
            searchInDB();
          } else {
            showLoading(false);
          }
        });
      } else {
        // Si IndexedDBManager n'est pas encore disponible, réessayer
        setTimeout(init, 100);
      }
    } catch (error) {
      console.error("Erreur de recherche:", error);
    }
  }

  // Fonction pour réinitialiser la pagination
  const resetPagination = () => {
    paginationState.currentPage = 1;
  };

  // Fonction pour gérer le tri des colonnes
  const handleColumnSort = (fieldKey) => {
    // Si c'est le même champ, inverser la direction
    if (sortState.field === fieldKey) {
      sortState.direction = sortState.direction === "asc" ? "desc" : "asc";
    } else {
      // Nouveau champ, commencer par ordre ascendant
      sortState.field = fieldKey;
      sortState.direction = "asc";
    }

    // Annoncer le changement de tri
    const fieldLabel = headingFieldsLabel[fieldKey]?.label?.[lang] || fieldKey;
    const directionLabel = sortState.direction === "asc" ?
      labelList.sortAsc_aria[lang] :
      labelList.sortDesc_aria[lang];

    announceToScreenReader(screenReaderText.sort.label[lang](fieldLabel, directionLabel));

    // Réinitialiser la pagination lors du tri
    resetPagination();

    // Relancer la recherche avec le nouveau tri
    searchInDB();
  };


  /**
   * Updates the visual state and accessibility attributes of all sort buttons in a data table.
   *
   * This function handles the display of sorting indicators by:
   * - Resetting all sort buttons to their default state (ascending)
   * - Applying appropriate CSS classes and ARIA attributes to indicate current sort state
   * - Updating button labels with localized text for screen readers
   *
   * The function relies on global variables:
   * - `sortState`: Object containing current sort field and direction
   * - `labelList`: Object containing localized labels for ARIA attributes
   * - `lang`: Current language code for localization
   *
   * @function updateSortButtons
   * @returns {void}
   *
   * @example
   * // Call after changing sort state to update UI
   * sortState.field = 'name';
   * sortState.direction = 'desc';
   * updateSortButtons();
   */
  const updateSortButtons = () => {
    const allSortButtons = document.querySelectorAll(".datatable-sort-button");

    allSortButtons.forEach(button => {
      const fieldKey = button.getAttribute("data-field");
      const parentTh = button.closest("th");

      // Vérifier que parentTh existe avant d'accéder à ses propriétés
      if (!parentTh) {
        console.warn("Parent th element not found for sort button");
        return;
      }

      // Retirer les classes de tri existantes
      parentTh.classList.remove("sort-asc", "sort-desc");
      button.setAttribute("data-sorting", "asc");

      // Réinitialiser l'état ARIA
      button.setAttribute("aria-sort", "none");
      const label = button.textContent;
      const sortLabel = labelList.sort_aria[lang];
      const ascLabel = labelList.sortAsc_aria[lang];
      button.setAttribute("aria-label", `${sortLabel} ${label} (${ascLabel})`);

      // Si c'est le champ actuel, ajouter la classe appropriée
      if (fieldKey === sortState.field) {
        parentTh.classList.add(`sort-${sortState.direction}`);
        button.setAttribute("data-sorting", sortState.direction);

        // Mettre à jour l'état ARIA
        const ariaSort = sortState.direction === "asc" ? "ascending" : "descending";
        button.setAttribute("aria-sort", ariaSort);

        const directionLabel = sortState.direction === "asc" ?
          (labelList.sortDesc_aria[lang]) :
          (labelList.sortAsc_aria[lang]);
        button.setAttribute("aria-label", `${sortLabel} ${label} (${directionLabel})`);
      }
    });
  };




  /*PAGINATION*/
  // Fonction pour créer un bouton de page dans un élément li
  const createPageButton = (pageNumber, isCurrent = false, totalPages = 1) => {
    const li = document.createElement("li");
    li.setAttribute("aria-setsize", totalPages);
    li.setAttribute("aria-posinset", pageNumber);
    const button = document.createElement("button");
    button.textContent = pageNumber;
    button.className = `pagination-btn page-btn ${isCurrent ? "active" : ""}`;
    button.disabled = isCurrent;
    button.setAttribute("aria-label", `${labelList.navItem_aria[lang]} ${pageNumber}`);

    if (isCurrent) {
      button.setAttribute("aria-current", "page");
    }

    if (!isCurrent) {
      button.addEventListener("click", () => {
        paginationState.currentPage = pageNumber;
        setTimeout(() => {
          if (typeof searchInDB === "function") {
            searchInDB();
          }
        }, 0);
      });
    }

    li.appendChild(button);
    return li;
  };

  // Fonction pour créer les points de suspension dans un élément li
  const createEllipsis = () => {
    const li = document.createElement("li");
    const span = document.createElement("span");
    span.textContent = "...";
    span.className = "pagination-ellipsis";
    li.appendChild(span);
    return li;
  };

  // Fonction pour créer le bouton précédent
  const createPreviousButton = (hasPreviousPage) => {
    const prevLi = document.createElement("li");
    const prevButton = document.createElement("button");
    prevButton.textContent = labelList.btnPrevious[lang];
    prevButton.className = "pagination-btn prev-btn";
    prevButton.disabled = !hasPreviousPage;
    prevButton.setAttribute("aria-label", labelList.btnPrevious_aria[lang]);

    if (hasPreviousPage) {
      prevButton.addEventListener("click", () => {
        paginationState.currentPage = Math.max(1, paginationState.currentPage - 1);
        setTimeout(() => {
          if (typeof searchInDB === "function") {
            searchInDB();
          }
        }, 0);
      });
    }

    prevLi.appendChild(prevButton);
    return prevLi;
  };

  // Fonction pour créer le bouton suivant
  const createNextButton = (hasNextPage, totalPages) => {
    const nextLi = document.createElement("li");
    const nextButton = document.createElement("button");
    nextButton.textContent = labelList.btnNext[lang];
    nextButton.className = "pagination-btn next-btn";
    nextButton.disabled = !hasNextPage;
    nextButton.setAttribute("aria-label", labelList.btnNext_aria[lang]);

    if (hasNextPage) {
      nextButton.addEventListener("click", () => {
        paginationState.currentPage = Math.min(totalPages, paginationState.currentPage + 1);
        setTimeout(() => {
          if (typeof searchInDB === "function") {
            searchInDB();
          }
        }, 0);
      });
    }

    nextLi.appendChild(nextButton);
    return nextLi;
  };

  // Fonction pour créer les numéros de page (toutes les pages)
  const createAllPageNumbers = (totalPages, currentPage, ol) => {
    for (let i = 1; i <= totalPages; i++) {
      ol.appendChild(createPageButton(i, currentPage === i, totalPages));
    }
  };

  // Fonction optimisée pour créer les numéros de page avec ellipses
  const createPageNumbersWithEllipses = (totalPages, currentPage, ol) => {
    const pagesInGroup = 3;
    const minEndGap = 2; // Seuil pour afficher les ellipses

    // Calculer le groupe de pages autour de la page courante de manière optimisée
    let startGroup = Math.max(1, currentPage - Math.floor(pagesInGroup / 2));
    let endGroup = Math.min(totalPages, startGroup + pagesInGroup - 1);

    // Ajuster si on est trop près de la fin (optimisation mathématique)
    if (endGroup === totalPages) {
      startGroup = Math.max(1, totalPages - pagesInGroup + 1);
    }

    // Utiliser DocumentFragment pour optimiser les manipulations DOM
    const fragment = document.createDocumentFragment();

    // Générer les pages du groupe principal en une seule boucle
    for (let i = startGroup; i <= endGroup; i++) {
      fragment.appendChild(createPageButton(i, currentPage === i, totalPages));
    }

    // Traitement optimisé des pages finales avec logique consolidée
    if (endGroup < totalPages) {
      const remainingPages = totalPages - endGroup;

      if (remainingPages > minEndGap) {
        // Ajouter les ellipses et les 3 dernières pages
        fragment.appendChild(createEllipsis());

        // Générer les 3 dernières pages en une boucle optimisée
        const lastPagesStart = Math.max(endGroup + 1, totalPages - 2);
        for (let i = lastPagesStart; i <= totalPages; i++) {
          fragment.appendChild(createPageButton(i, currentPage === i, totalPages));
        }
      } else {
        // Afficher les pages restantes sans ellipses (moins d'allocations)
        for (let i = endGroup + 1; i <= totalPages; i++) {
          fragment.appendChild(createPageButton(i, currentPage === i, totalPages));
        }
      }
    }

    // Une seule manipulation DOM pour ajouter tous les éléments
    ol.appendChild(fragment);
  };

  // Fonction pour créer les numéros de page
  const createPageNumbers = (totalPages, currentPage, ol) => {
    if (totalPages <= 6) {
      // Si 6 pages ou moins, afficher toutes les pages
      createAllPageNumbers(totalPages, currentPage, ol);
    } else {
      // Plus de 6 pages: afficher avec ellipses
      createPageNumbersWithEllipses(totalPages, currentPage, ol);
    }
  };

  // Fonction optimisée pour créer les contrôles de pagination
  const createPaginationControls = (pagination) => {
    const paginationDiv = document.createElement("nav");
    paginationDiv.className = "datatable-pagination";

    const { currentPage, totalPages, hasNextPage, hasPreviousPage } = pagination;

    // Early return pour éviter la création d'éléments inutiles
    if (totalPages <= 1) {
      return paginationDiv;
    }

    // Utiliser DocumentFragment pour optimiser les manipulations DOM
    const fragment = document.createDocumentFragment();

    // Créer la liste ordonnée
    const ol = document.createElement("ol");
    ol.className = "datatable-pagination-list";

    // Construire tous les éléments de pagination en une seule fois
    const paginationElements = [
      createPreviousButton(hasPreviousPage),
      ...getPaginationNumbers(totalPages, currentPage),
      createNextButton(hasNextPage, totalPages)
    ];

    // Ajouter tous les éléments au fragment en une seule boucle
    paginationElements.forEach(element => ol.appendChild(element));

    // Une seule manipulation DOM
    fragment.appendChild(ol);
    paginationDiv.appendChild(fragment);

    return paginationDiv;
  };

  // Fonction helper optimisée pour générer les numéros de page
  const getPaginationNumbers = (totalPages, currentPage) => {
    const pageElements = [];

    if (totalPages <= 6) {
      // Générer toutes les pages en une seule boucle
      for (let i = 1; i <= totalPages; i++) {
        pageElements.push(createPageButton(i, currentPage === i, totalPages));
      }
    } else {
      // Logique des ellipses optimisée
      pageElements.push(...createPageNumbersWithEllipsesOptimized(totalPages, currentPage));
    }

    return pageElements;
  };

  // Version optimisée qui retourne un array au lieu de manipuler le DOM
  const createPageNumbersWithEllipsesOptimized = (totalPages, currentPage) => {
    const pagesInGroup = 3;
    const minEndGap = 2;
    const elements = [];

    // Calculer le groupe de pages autour de la page courante
    let startGroup = Math.max(1, currentPage - Math.floor(pagesInGroup / 2));
    let endGroup = Math.min(totalPages, startGroup + pagesInGroup - 1);

    // Ajuster si on est trop près de la fin
    if (endGroup === totalPages) {
      startGroup = Math.max(1, totalPages - pagesInGroup + 1);
    }

    // Générer les pages du groupe principal
    for (let i = startGroup; i <= endGroup; i++) {
      elements.push(createPageButton(i, currentPage === i, totalPages));
    }

    // Traitement optimisé des pages finales
    if (endGroup < totalPages) {
      const remainingPages = totalPages - endGroup;

      if (remainingPages > minEndGap) {
        elements.push(createEllipsis());

        const lastPagesStart = Math.max(endGroup + 1, totalPages - 2);
        for (let i = lastPagesStart; i <= totalPages; i++) {
          elements.push(createPageButton(i, currentPage === i, totalPages));
        }
      } else {
        for (let i = endGroup + 1; i <= totalPages; i++) {
          elements.push(createPageButton(i, currentPage === i, totalPages));
        }
      }
    }

    return elements;
  };

  // Fonction optimisée pour afficher un message "aucun résultat"
  const displayNoResults = (container) => {
    // Validation précoce du container
    if (!container) {
      console.warn("Container non défini pour displayNoResults");
      return;
    }

    // Vider le container une seule fois
    container.innerHTML = "";

    // Utiliser DocumentFragment pour optimiser les manipulations DOM
    const fragment = document.createDocumentFragment();

    // Créer la structure complète en une seule fois
    const noResultsDiv = document.createElement("div");
    noResultsDiv.className = "no-results";


    // Optimiser les attributs d'accessibilité
    const ariaAttributes = {
      "role": "status",
      "aria-live": "polite"
    };

    Object.entries(ariaAttributes).forEach(([attr, value]) => {
      noResultsDiv.setAttribute(attr, value);
    });

    // Créer et ajouter le contenu textuel
    const noResultsP = document.createElement("p");
    noResultsP.className = "hq-titre3";
    noResultsP.textContent = labelList.noResult[lang];

    // Assembler la structure
    noResultsDiv.appendChild(noResultsP);
    fragment.appendChild(noResultsDiv);

    // Une seule manipulation DOM finale
    container.appendChild(fragment);
  };


  // Fonction pour obtenir les champs à afficher
  const getFieldsToShow = () => {
    console.log("Active List:", activeList, activeList.name);
    return activeList && headingFieldsList[activeList.name][g_listOrigin]
      ? headingFieldsList[activeList.name][g_listOrigin]
      : Object.keys(headingFieldsList[activeList.name][g_listOrigin]);
  };

  /**
   * Crée l'en-tête du tableau de manière optimisée.
   * @param {Array} fieldsToShow - Tableau des champs à afficher
   * @returns {HTMLElement} L'élément thead optimisé
   */
  const createTableHeader = (fieldsToShow) => {
    // Validation précoce et filtrage optimisé des champs valides
    const validFields = fieldsToShow.filter(fieldKey => fieldKey && fieldKey !== "");
    if (!validFields.length) {
      console.warn("Aucun champ valide pour l'en-tête du tableau");
      return document.createElement("thead");
    }
console.log("Création de l'en-tête du tableau avec les champs:", validFields);
    // Utiliser DocumentFragment pour optimiser les manipulations DOM
    const fragment = document.createDocumentFragment();
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    // Précalculer les labels d'accessibilité une seule fois
    const ariaLabels = {
      sort: labelList.sort_aria[lang],
      asc: labelList.sortAsc_aria[lang],
      desc: labelList.sortDesc_aria[lang]
    };

    // Configuration des attributs de bouton par défaut
    const defaultButtonAttributes = {
      "data-sorting": "asc",
      "aria-sort": "none",
      "tabindex": "0"
    };

    // Gestionnaire d'événements unifié et optimisé
    const handleSortEvent = (e, fieldKey) => {
      if (e.type === "click" || (e.type === "keydown" && (e.key === "Enter" || e.key === " "))) {
        if (e.type === "keydown") e.preventDefault();
        handleColumnSort(fieldKey);
      }
    };

    // Créer tous les éléments d'en-tête en une seule boucle
    validFields.forEach(fieldKey => {
      const field = (g_listOrigin === "es" ? headingFieldsLabel_es : headingFieldsLabel)[fieldKey];
      console.log("Création de l'en-tête pour le champ:", fieldKey, field);
      if (!field) {
        console.warn(`Champ non trouvé dans headingFieldsLabel: ${fieldKey}`);
        return;
      }

      // Créer l'élément th avec ses attributs
      const th = document.createElement("th");
      th.className = `col-${fieldKey}`;
      th.setAttribute("scope", "col");

      // Calculer le label de manière optimisée
      let label = field.label?.[lang] || fieldKey;
/********************* */

      // Cas spécifique pour "aide_financiere_a" qui peut avoir un label différent selon la liste active
      if (activeList.name !== "entrepreneur-plex" && fieldKey === "aide_financiere_a") {
        label = headingFieldsLabel.aide_financiere?.label?.[lang] || label;
      }
      // Cas spécfique pour cooling_capacity_btu_h qui peut avoir un label différent pour les ménages à revenu modeste
      if (activeList.name === "menages-revenu-modeste" && fieldKey === "cooling_capacity_btu_h") {
        label = headingFieldsLabel_custom.cooling_capacity_btu_h?.label?.[lang] || label;
      }

/****************** */
      // Créer le bouton avec tous ses attributs en une seule fois
      const button = document.createElement("button");
      button.className = "datatable-sort-button";
      button.textContent = label;
      button.setAttribute("data-field", fieldKey);

      // Appliquer tous les attributs par défaut en batch
      Object.entries(defaultButtonAttributes).forEach(([attr, value]) => {
        button.setAttribute(attr, value);
      });

      // Définir l'aria-label optimisé
      button.setAttribute("aria-label", `${ariaLabels.sort} ${label} (${ariaLabels.asc})`);

      // Gestionnaire d'événements unifié pour clic et clavier
      const eventHandler = (e) => handleSortEvent(e, fieldKey);
      button.addEventListener("click", eventHandler);
      button.addEventListener("keydown", eventHandler);

      // Assembler la structure
      th.appendChild(button);
      headerRow.appendChild(th);
    });

    // Une seule manipulation DOM finale
    fragment.appendChild(headerRow);
    thead.appendChild(fragment);

    return thead;
  };

  // Fonction pour formater une valeur selon son type
  const formatCellValue = (fieldKey, value) => {
    if (["puissance","capacity"].some(word => fieldKey.includes(word)) && value /*&& !isNaN(value)*/) {
      return helpers.formatThousand(value);
    } else if (["aide_financiere","TTG_"].some(word => fieldKey.includes(word)) && value && !isNaN(value)) {
      return helpers.formatCurrency(value);
    } else if (["haut_rendement","cold_climate"].some(word => fieldKey.includes(word)) && value) {
      return value === "1" || value === "true" || value === "Oui" || value === "OUI" || value === "Yes" || value === "YES" ?
        (lang === "en" ? "Yes" : "Oui") :
        (lang === "en" ? "No" : "Non");
    }
    console.log(`Valeur du champ ${fieldKey}:`, value);
    return value;
  };

  // Fonction pour créer le corps du tableau
  const createTableBody = (items, fieldsToShow) => {
    const tbody = document.createElement("tbody");

    items.forEach(item => {
      const row = document.createElement("tr");
      fieldsToShow.forEach(fieldKey => {
        // Ignorer les champs vides
        if (fieldKey === "") return;

        const field = (g_listOrigin === "es" ? headingFieldsLabel_es : headingFieldsLabel)[fieldKey];
        if (field) {
          const td = document.createElement("td");
          td.className = `col-${fieldKey}`;

          const rawValue = item[fieldKey] || "";

          const formattedValue = formatCellValue(fieldKey, rawValue);

          td.textContent = formattedValue;
          row.appendChild(td);
        }
      });

      tbody.appendChild(row);
    });

    return tbody;
  };



  /**
   * Creates an HTML select element for pagination options.
   *
   * @function createPaginationSelector
   * @returns {string} HTML string containing a select element with pagination options
   *
   * @description
   * This function generates a dropdown selector that allows users to choose how many items
   * to display per page. It validates each pagination option, filtering out invalid values,
   * and marks the currently selected option. The select element includes proper ARIA labeling
   * for accessibility.
   *
   * @example
   * // Returns: '<select class="datatable-selector" aria-label="Items per page"><option value="10" selected="">10</option><option value="25">25</option></select>'
   * const paginationHTML = createPaginationSelector();
   *
   * @requires paginationOptions - Array of pagination options to validate and display
   * @requires showListItems - Current number of items being displayed (for selection state)
   * @requires labelList.navItemResults_aria - Localized aria-label text object
   * @requires lang - Current language code for localization
   */
  const createPaginationSelector = () => {
    const options = paginationOptions.map(option => {
      const validatedOption = parseInt(option);
      if (isNaN(validatedOption) || validatedOption <= 0) {
        console.warn(`Option de pagination invalide: ${option}`);
        return "";
      }
      const selected = validatedOption === showListItems ? 'selected=""' : '';
      return `<option value="${validatedOption}" ${selected}>${validatedOption}</option>`;
    }).join("");

    const selectLabel = labelList.navItemResults_aria[lang];
    return `<select class="datatable-selector" aria-label="${selectLabel}">${options}</select>`;
  };


  /**
   * Creates and returns a DOM element containing result information and pagination controls for a data table.
   *
   * @param {Object} pagination - The pagination object containing display information
   * @param {number} pagination.startIndex - The starting index of currently displayed items
   * @param {number} pagination.endIndex - The ending index of currently displayed items
   * @param {number} pagination.totalItems - The total number of items in the dataset
   * @returns {HTMLDivElement} A div element with class "datatable-top" containing the complete result info structure
   *
   * @description
   * This function creates a complex DOM structure that includes:
   * - Total results count display
   * - CSV download button
   * - Per-page results selector
   * - Current page range information
   * The generated element provides user interface controls for data table navigation and export functionality.
   */
  const createResultInfo = (pagination) => {
    // Validation précoce et extraction des valeurs
    if (!pagination || typeof pagination.totalItems === "undefined") {
      console.warn("Pagination object invalide ou manquant");
      return document.createElement("div");
    }

    const { startIndex, endIndex, totalItems } = pagination;
    const formattedTotalItems = helpers.formatThousand(totalItems);

    // Utiliser DocumentFragment pour optimiser les manipulations DOM
    const fragment = document.createDocumentFragment();
    const resultInfo = document.createElement("div");
    resultInfo.className = "datatable-top";

    // Créer la barre d'informations de manière optimisée
    const infoBarFragment = createInfoBarOptimized(formattedTotalItems);

    // Créer la section per-page de manière optimisée
    const perPageFragment = createPerPageSectionOptimized(startIndex, endIndex, formattedTotalItems);

    // Assembler tous les éléments en une seule fois
    fragment.appendChild(infoBarFragment);
    fragment.appendChild(perPageFragment);
    resultInfo.appendChild(fragment);

    return resultInfo;
  };

  // Fonction helper optimisée pour créer la barre d'informations
  const createInfoBarOptimized = (formattedTotalItems) => {
    const infoBar = document.createElement("div");
    infoBar.className = "info-bar";

    // Créer la structure des résultats totaux en une seule fois
    const totalResultsDiv = document.createElement("div");
    totalResultsDiv.className = "total-results js-total-results";

    // Optimiser la création du contenu textuel
    const totalSpan = document.createElement("span");
    totalSpan.textContent = formattedTotalItems;
    const textNode = document.createTextNode(lang === "en" ? " results" : " résultats");

    // Utiliser DocumentFragment pour réduire les manipulations
    const totalFragment = document.createDocumentFragment();
    totalFragment.appendChild(totalSpan);
    totalFragment.appendChild(textNode);
    totalResultsDiv.appendChild(totalFragment);

    // Créer la toolbar avec le bouton CSV optimisé
    const toolbarDiv = document.createElement("div");
    toolbarDiv.className = "info-toolbar";

    const widget = document.createElement("div");
    widget.className = "datatable-widget";

    // Créer le bouton CSV de manière sécurisée
    const csvButton = document.createElement("button");
    csvButton.className = "btn-widget-csv js-btn-widget-csv";
    csvButton.textContent = labelList.tableDownload[lang];

    widget.appendChild(csvButton);
    toolbarDiv.appendChild(widget);

    // Assembler la barre d'informations
    const infoBarFragment = document.createDocumentFragment();
    infoBarFragment.appendChild(totalResultsDiv);
    infoBarFragment.appendChild(toolbarDiv);
    infoBar.appendChild(infoBarFragment);

    return infoBar;
  };

  // Fonction helper optimisée pour créer la section per-page
  const createPerPageSectionOptimized = (startIndex, endIndex, formattedTotalItems) => {
    const perPageDiv = document.createElement("div");
    perPageDiv.className = "per-page js-per-page";

    // Créer le dropdown de pagination optimisé
    const dropdownDiv = document.createElement("div");
    dropdownDiv.className = "datatable-dropdown";

    const label = document.createElement("label");

    // Créer le span de label
    const labelSpan = document.createElement("span");
    labelSpan.textContent = paginationLabel.resultPerPage[lang];

    // Créer le sélecteur et l'ajouter au label de manière sécurisée
    const selectorDiv = document.createElement("div");
    selectorDiv.innerHTML = createPaginationSelector();

    // Assembler le label avec DocumentFragment
    const labelFragment = document.createDocumentFragment();
    labelFragment.appendChild(labelSpan);
    labelFragment.appendChild(selectorDiv.firstElementChild); // Extraire le select
    label.appendChild(labelFragment);

    dropdownDiv.appendChild(label);

    // Créer l'information de pagination
    const infoDiv = document.createElement("div");
    infoDiv.className = "datatable-info";
    infoDiv.textContent = paginationLabel.resultsFound[lang](startIndex, endIndex, formattedTotalItems);

    // Assembler la section per-page
    const perPageFragment = document.createDocumentFragment();
    perPageFragment.appendChild(dropdownDiv);
    perPageFragment.appendChild(infoDiv);
    perPageDiv.appendChild(perPageFragment);

    return perPageDiv;
  };

  // Configuration des constantes pour l'optimisation des gestionnaires d'événements
  const EVENT_CONFIG = {
    DEBOUNCE_DELAY: 300,
    VALIDATION_LIMITS: {
      MIN_VALUE: 1,
      MAX_VALUE: 1000
    },
    SELECTORS: {
      PAGINATION_SELECTOR: ".datatable-selector",
      CSV_BUTTON: ".js-btn-widget-csv"
    }
  };

  // Fonction optimisée pour configurer les gestionnaires d'événements
  const setupEventHandlers = (container) => {
    // Validation précoce du container
    if (!container) {
      console.warn("Container non fourni pour setupEventHandlers");
      return;
    }

    // Configuration optimisée du gestionnaire de pagination
    setupPaginationHandler(container);

    // Configuration optimisée du gestionnaire CSV
    setupCSVHandler(container);
  };

  // Fonction helper optimisée pour le gestionnaire de pagination
  const setupPaginationHandler = (container) => {
    const paginationSelector = container.querySelector(EVENT_CONFIG.SELECTORS.PAGINATION_SELECTOR);
    if (!paginationSelector) {
      return; // Early return si l'élément n'existe pas
    }

    // Gestionnaire optimisé avec validation améliorée
    const handlePaginationChange = (e) => {
      try {
        // Validation précoce et stricte de la valeur
        const rawValue = e.target?.value;
        if (!rawValue) {
          console.warn("Valeur de pagination manquante");
          return;
        }

        const newValue = parseInt(rawValue, 10);
        const { MIN_VALUE, MAX_VALUE } = EVENT_CONFIG.VALIDATION_LIMITS;

        // Validation consolidée en une seule condition
        if (!Number.isInteger(newValue) || newValue < MIN_VALUE || newValue > MAX_VALUE) {
          console.warn(`Valeur de pagination invalide: ${rawValue} (doit être entre ${MIN_VALUE} et ${MAX_VALUE})`);
          return;
        }

        // Mise à jour optimisée de l'état
        updatePaginationState(newValue);

        // Debounce optimisé pour éviter les appels multiples
        handleDebouncedSearch();

      } catch (error) {
        console.error("Erreur dans le gestionnaire de pagination:", error);
      }
    };

    // Attacher l'événement une seule fois
    paginationSelector.addEventListener("change", handlePaginationChange, { passive: true });
  };

  // Fonction helper pour mettre à jour l'état de pagination
  const updatePaginationState = (newValue) => {
    showListItems = newValue;
    resetPagination();

    // Annoncer le changement pour les lecteurs d'écran (si disponible)
    if (typeof announceToScreenReader === "function" && screenReaderText?.itemsPerPage?.label?.[lang]) {
      announceToScreenReader(screenReaderText.itemsPerPage.label[lang](newValue));
    }
  };

  // Fonction optimisée pour gérer le debounce
  const handleDebouncedSearch = () => {
    // Nettoyer le timeout précédent
    if (window.searchTimeout) {
      clearTimeout(window.searchTimeout);
    }

    // Créer un nouveau timeout optimisé
    window.searchTimeout = setTimeout(() => {
      if (typeof searchInDB === "function") {
        searchInDB();
      } else {
        console.warn("Fonction searchInDB non disponible");
      }
    }, EVENT_CONFIG.DEBOUNCE_DELAY);
  };

  // Fonction helper optimisée pour le gestionnaire CSV
  const setupCSVHandler = (container) => {
    const csvButton = container.querySelector(EVENT_CONFIG.SELECTORS.CSV_BUTTON);
    if (!csvButton) {
      return; // Early return si l'élément n'existe pas
    }

    // Gestionnaire optimisé pour l'export CSV
    const handleCSVExport = async (e) => {
      e.preventDefault();

      try {
        // Validation précoce des données globales
        if (!window.allMatchingItemsGlobal) {
          announceScreenReaderMessage(screenReaderText?.exportFail?.label?.[lang] || "Export failed");
          return;
        }

        // Extraction optimisée des données
        const allData = window.allMatchingItemsGlobal;

        // Validation de la fonction d'export
        if (typeof exportToCSV !== "function") {
          console.error("Fonction exportToCSV non disponible");
          announceScreenReaderMessage("Export function not available");
          return;
        }

        // Exécuter l'export
        await exportToCSV(allData);

        // Annoncer le succès avec validation
        const successMessage = screenReaderText?.exportSuccess?.label?.[lang];
        if (successMessage && typeof successMessage === "function") {
          announceScreenReaderMessage(successMessage(activeList?.name || "data"));
        } else {
          announceScreenReaderMessage("Export completed successfully");
        }

      } catch (error) {
        console.error("Erreur lors de l'export CSV:", error);
        announceScreenReaderMessage("Export failed due to an error");
      }
    };

    // Attacher l'événement avec options optimisées
    csvButton.addEventListener("click", handleCSVExport, { passive: false });
  };

  // Fonction helper optimisée pour les annonces aux lecteurs d'écran
  const announceScreenReaderMessage = (message) => {
    if (typeof announceToScreenReader === "function" && message) {
      announceToScreenReader(message);
    }
  };


  // Fonction pour gérer l'affichage des colonnes conditionnelles
  const handleConditionalColumns = () => {
    const checkboxPuissanceNominale = document.querySelector(SELECTORS.CHECKBOX_PUISSANCE_NOMINALE);
    if (checkboxPuissanceNominale && checkboxPuissanceNominale.checked) {
      showHideColumn(`col-${helpers.correlateFields("puissance_nominale",g_listOrigin)}`);
    }

    const checkboxPuissanceMoins8 = document.querySelector(SELECTORS.CHECKBOX_PUISSANCE_MOINS_8);
    if (checkboxPuissanceMoins8 && checkboxPuissanceMoins8.checked) {
      showHideColumn(`col-${helpers.correlateFields("puissance_moins_8",g_listOrigin)}`);
    }
  };


  // Fonction pour créer et configurer le tableau principal
  const createTableElement = (fieldsToShow, items) => {
    const table = document.createElement("table");
    table.className = "tableau-resultats js-tableau-resultats";

    // Améliorer l'accessibilité du tableau
    const tableCaption = document.createElement("caption");
    tableCaption.textContent = labelList.caption[lang];
    tableCaption.className = "sr-only";
    table.appendChild(tableCaption);

    // Ajouter les attributs ARIA
    table.setAttribute("role", "table");
    table.setAttribute("aria-label", labelList.table_aria[lang]);

    // Créer l'en-tête et le corps du tableau en une seule fois
    const fragment = document.createDocumentFragment();
    fragment.appendChild(createTableHeader(fieldsToShow));
    fragment.appendChild(createTableBody(items, fieldsToShow));
    table.appendChild(fragment);

    return table;
  };

  // Fonction pour créer le wrapper du tableau
  const createTableWrapper = (table) => {
    const tableWrapper = document.createElement("div");
    tableWrapper.className = "datatable-wrapper";
    tableWrapper.appendChild(table);
    return tableWrapper;
  };

  // Fonction pour créer le séparateur et le contenu légal
  const createFooterElements = () => {
    const fragment = document.createDocumentFragment();

    const separateur = document.createElement("div");
    separateur.classList.add("hq-separateur");
    fragment.appendChild(separateur);

    return fragment;
  };

  // Fonction principale pour afficher les résultats de recherche (optimisée)
  const displaySearchResults = (result, containerId = SELECTORS.RESULTS_CONTAINER) => {

    const container = document.querySelector(containerId);
    if (!container) {
      console.error(`Container ${containerId} introuvable`);
      showLoading(false);
      return;
    }

    // Gérer la nouvelle structure de retour avec pagination
    const items = result.items || result;
    const pagination = result.pagination || null;

    // Vérification précoce pour les résultats vides
    if (!items?.length) {
      displayNoResults(container);
      showLoading(false);
      return;
    }

    try {
      // Vider le conteneur une seule fois au début
      container.innerHTML = "";

      // Obtenir les champs à afficher
      const fieldsToShow = getFieldsToShow();

      // Utiliser DocumentFragment pour optimiser les manipulations DOM
      const fragment = document.createDocumentFragment();

      // Créer tous les éléments
      const resultInfo = createResultInfo(pagination);
      const table = createTableElement(fieldsToShow, items);
      const tableWrapper = createTableWrapper(table);
      const footerElements = createFooterElements();

      // Ajouter les contrôles de pagination si disponibles
      let paginationControls = null;
      if (pagination) {
        paginationControls = createPaginationControls(pagination);
      }

      // Assembler tous les éléments dans le fragment
      fragment.appendChild(resultInfo);
      fragment.appendChild(tableWrapper);
      if (paginationControls) {
        fragment.appendChild(paginationControls);
      }
      fragment.appendChild(footerElements);

      // Une seule manipulation DOM pour ajouter tout le contenu
      container.appendChild(fragment);

      // Masquer les colonnes conditionnelles par défaut
      hideColumn(`col-${helpers.correlateFields("puissance_moins_8",g_listOrigin)}`);
      hideColumn(`col-${helpers.correlateFields("puissance_nominale",g_listOrigin)}`);

      // Configurer les gestionnaires d'événements après l'ajout au DOM
      setupEventHandlers(container);
      handleConditionalColumns();

      // Annoncer les résultats aux lecteurs d'écran
      const totalResults = pagination ? pagination.totalItems : items.length;
      const resultMessage = paginationLabel.resultMessage[lang](totalResults);
      announceToScreenReader(resultMessage);

      // Scroll vers les résultats
      container.scrollIntoView({ behavior: "smooth" });

      return table;

    } catch (error) {
      console.error("Erreur lors de l'affichage des résultats:", error);
      displayNoResults(container);
    } finally {
      showLoading(false);
    }
  };

  // Fonction pour valider les entrées texte
  const validateInput = (selector, defaultValue = "") => {
    const element = document.querySelector(selector);
    if (!element) return defaultValue;
    const value = element.value.trim();
    // Limiter la longueur des entrées texte
    return value.length > 100 ? value.substring(0, 100) : value;
  };

  // Fonction pour valider les entrées numériques
  const validateNumericInput = (selector, min = 0, max = Number.MAX_SAFE_INTEGER) => {
    const element = document.querySelector(selector);
    if (!element) return "";
    const value = element.value.trim();
    if (value === "") return "";
    const num = parseFloat(value);
    if (isNaN(num) || num < min || num > max) {
      console.warn(`Valeur numérique invalide pour ${selector}:`, value);
      return "";
    }
    return value;
  };

  // Configuration des champs de critères de recherche
  const SEARCH_CRITERIA_CONFIG = {
    text: [
      { key: "modeleExterne", selector: SELECTORS.MODELE_EXTERNE },
      { key: "modeleInterne", selector: SELECTORS.MODELE_INTERNE },
      { key: "fournaise", selector: SELECTORS.FOURNAISE }
    ],
    numeric: [
      { key: "puissanceNominaleMin", selector: SELECTORS.PUISSANCE_NOMINALE_MIN },
      { key: "puissanceNominaleMax", selector: SELECTORS.PUISSANCE_NOMINALE_MAX },
      { key: "puissanceMoins8Min", selector: SELECTORS.PUISSANCE_MOINS_8_MIN },
      { key: "puissanceMoins8Max", selector: SELECTORS.PUISSANCE_MOINS_8_MAX },
      { key: "aideFinanciereMin", selector: SELECTORS.AIDE_FINANCIERE_MIN },
      { key: "aideFinanciereMax", selector: SELECTORS.AIDE_FINANCIERE_MAX }
    ]
  };

  // Fonction pour obtenir la valeur du checkbox haute efficacité
  const getHautRendementValue = () => {
    const checkboxElement = document.querySelector(SELECTORS.CHECKBOX_THERMOPOMPE_HE);
    const checkvoxElementEl = (g_listOrigin === "es") ? checkboxElement?.checked ? "Yes" : null : checkboxElement?.checked ? "Oui" : null;
    return checkvoxElementEl || null;
  };

  // Fonction pour obtenir la valeur du checkbox Admissible Bonification
  const getAdmissibleBonificationValue = () => {
    const checkboxElement = document.querySelector(SELECTORS.CHECKBOX_ADMISSIBLE_BONIFICATION);
    const checkvoxElementEl = checkboxElement?.checked ? "VRAI" : null;///(g_listOrigin === "es") ? checkboxElement?.checked ? "VRAI" : null : checkboxElement?.checked ? "VRAI" : null;
    console.log(`Valeur du checkbox Admissible Bonification:`, checkvoxElementEl);
    return checkvoxElementEl || null;
  };

  // Fonction pour collecter les critères texte
  const collectTextCriteria = () => {
    const criteria = {};
    SEARCH_CRITERIA_CONFIG.text.forEach(({ key, selector }) => {
      criteria[key] = validateInput(selector);
    });
    return criteria;
  };

  // Fonction pour collecter les critères numériques
  const collectNumericCriteria = () => {
    const criteria = {};
    const numericLimits = { min: 0, max: 1000000 };

    SEARCH_CRITERIA_CONFIG.numeric.forEach(({ key, selector }) => {
      criteria[key] = validateNumericInput(selector, numericLimits.min, numericLimits.max);
    });
    return criteria;
  };

  // Fonction optimisée pour collecter tous les critères de recherche
  const collectSearchCriteria = () => {
    try {
      // Collecter tous les types de critères en parallèle
      const textCriteria = collectTextCriteria();
      const numericCriteria = collectNumericCriteria();
      const hautRendement = getHautRendementValue();
      const admissibleBonification = getAdmissibleBonificationValue();

      // Combiner tous les critères en un seul objet
      return {
        ...textCriteria,
        ...numericCriteria,
        hautRendement,
        admissibleBonification
      };

    } catch (error) {
      console.error("Erreur lors de la collecte des critères de recherche:", error);
      // Retourner un objet vide en cas d'erreur pour éviter les plantages
      return {
        modeleExterne: "",
        modeleInterne: "",
        fournaise: "",
        puissanceNominaleMin: "",
        puissanceNominaleMax: "",
        puissanceMoins8Min: "",
        puissanceMoins8Max: "",
        aideFinanciereMin: "",
        aideFinanciereMax: "",
        hautRendement: null,
        admissibleBonification: null
      };
    }
  };

  // Fonction pour récupérer les marques sélectionnées
  const getSelectedMarques = () => {
    let selectedMarques = [];

    if (window.initMarquesSelector) {
      try {
        const marquesSelector = window.initMarquesSelector;
        if (marquesSelector && marquesSelector.getSelectedMarques) {
          selectedMarques = marquesSelector.getSelectedMarques();
        }
      } catch (error) {
        console.warn("Erreur lors de la récupération des marques:", error);
      }
    }

    return selectedMarques;
  };

  // Fonction ultra-optimisée pour construire les critères de recherche
  const buildSearchCriteria = (criteria, selectedMarques) => {
    // Validation précoce combinée avec destructuring optionnel
    const builderMethod = window.IndexedDBManager?.buildSearchCriteria;
    if (!builderMethod || !criteria) {
      console.warn("IndexedDBManager.buildSearchCriteria ou critères non disponibles");
      return null;
    }

    try {
      const searchBuilder = builderMethod();
      if (!searchBuilder) {
        console.warn("searchBuilder est null ou undefined");
        return null;
      }

      // Configuration des critères avec mapping de données optimisé
      const criteriaMapping = [
        [helpers.correlateFields("modele_exterieur",g_listOrigin), criteria.modeleExterne, "contains"],
        [helpers.correlateFields("modele_interieur",g_listOrigin), criteria.modeleInterne, "contains"],
        [helpers.correlateFields("fournaise",g_listOrigin), criteria.fournaise, "contains"],
        [helpers.correlateFields("haut_rendement",g_listOrigin), criteria.hautRendement, "equals"],
        [helpers.correlateFields("admissible_bonification",g_listOrigin), criteria.admissibleBonification, "equals"]
      ];

      // Application des critères texte en batch
      criteriaMapping.forEach(([field, value, operator]) => {
        if (value) searchBuilder.addTextCriteria(field, value, operator);
      });

      // Application des critères de plage en batch
      const rangeCriteria = [
        [helpers.correlateFields("puissance_nominale",g_listOrigin), criteria.puissanceNominaleMin, criteria.puissanceNominaleMax],
        [helpers.correlateFields("puissance_moins_8",g_listOrigin), criteria.puissanceMoins8Min, criteria.puissanceMoins8Max]
      ];

        rangeCriteria.forEach(([field, min, max]) => {
          if (min || max) searchBuilder.addRangeCriteria(field, min, max);
        });

/**************************************/
      // Critère multi-champs pour aide financière (uniquement si nécessaire)
       if (criteria.aideFinanciereMin || criteria.aideFinanciereMax) {
        tempCriteriaA = (g_listOrigin === "es") ?  helpers.correlateFields(`aide_financiere_a_${activeList.name}`,g_listOrigin) :  "aide_financiere_a";
        tempCriteriaB = (g_listOrigin === "es") ?  helpers.correlateFields(`aide_financiere_b_${activeList.name}`,g_listOrigin) :  "aide_financiere_b";
        console.log("Ajout du critère multi-champs pour aide financière:", tempCriteriaA, tempCriteriaB);
        searchBuilder.addMultiFieldRangeCriteria(
          [tempCriteriaA, tempCriteriaB],
          criteria.aideFinanciereMin,
          criteria.aideFinanciereMax,
          "OR"
        );
      }
/****************************************/

      // Traitement optimisé des marques avec filter + map combinés
      let marqueTemp = helpers.correlateFields("marque",g_listOrigin);
      if (selectedMarques?.length) {
        console.log("Traitement des marques sélectionnées");
        const marqueNames = selectedMarques
          .map(marqueTemp => marqueTemp.name || marqueTemp)
          .filter(Boolean); // Éliminer les valeurs falsy

        if (marqueNames.length) {
          console.log("Ajout du critère de marque avec les marques sélectionnées:", marqueNames);
          searchBuilder.addInCriteria(helpers.correlateFields("marque",g_listOrigin), marqueNames);//([helpers.correlateFields("marque",g_listOrigin), marqueNames]);
        }
      }
console.log("Critères de recherche construits:", searchBuilder.getCriteria());
      return searchBuilder.getCriteria();

    } catch (error) {
      console.error("Erreur lors de la construction des critères de recherche:", error);
      return null;
    }
  };  // Fonction  pour préparer les options de recherche
  const prepareSearchOptions = (searchCriteria) => {
    const searchOptions = searchCriteria ? { criteria: searchCriteria } : null;

    // Vérifier que paginationState est défini
    if (!paginationState) {
      console.warn("paginationState non défini");
      return {
        sortOptions: { field: sortState.field, direction: sortState.direction },
        searchOptions: searchOptions,
        paginationOptions: { page: 1 }
      };
    }

    const paginationOptions = {
      page: paginationState.currentPage || 1
    };

    // Vérifier que sortState est défini
    if (!sortState) {
      console.warn("sortState non défini");
      return {
        sortOptions: { field: [helpers.correlateFields("marque",g_listOrigin)], direction: "asc" },
        searchOptions: searchOptions,
        paginationOptions: paginationOptions
      };
    }

    return {
      sortOptions: { field: sortState.field, direction: sortState.direction },
      searchOptions: searchOptions,
      paginationOptions: paginationOptions
    };
  };

  // Fonction optimisée pour créer un message d'erreur utilisateur
  const createErrorDisplay = (container, userErrorMessage) => {
    const errorDiv = document.createElement("div");
    errorDiv.className = "error-message";
    errorDiv.setAttribute("role", "alert");
    errorDiv.setAttribute("aria-live", "assertive");
    errorDiv.textContent = userErrorMessage;

    container.innerHTML = "";
    container.appendChild(errorDiv);
  };

  // Fonction pour gérer les erreurs de recherche (optimisée)
  const handleSearchError = (error) => {
    const errorMessage = error?.message || "Erreur inconnue";
    console.error("Erreur lors de la recherche dans la base de données:", errorMessage);

    // Annoncer l'erreur aux lecteurs d'écran
    const userErrorMessage = labelList.errorMessage[lang];
    announceToScreenReader(userErrorMessage);

    // Afficher un message d'erreur à l'utilisateur
    const container = document.querySelector(SELECTORS.RESULTS_CONTAINER);
    if (container) {
      createErrorDisplay(container, userErrorMessage);
    }

    // Log détaillé pour le debugging (en développement uniquement)
    if (typeof DEBUG !== "undefined" && DEBUG) {
      console.error("Détails de l'erreur:", error?.stack || error);
    }
  };

  // Fonction pour valider les prérequis de recherche
  const validateSearchPrerequisites = () => {
    if (!window.IndexedDBManager?.getTopItemsFromDB) {
      console.warn("IndexedDBManager non disponible");
      return false;
    }

    if (!activeList?.file) {
      console.warn("activeList ou activeList.file non défini");
      return false;
    }

    return true;
  };

  // Fonction pour préparer les données de recherche
  const prepareSearchData = () => {
    const searchCriteria = collectSearchCriteria();
    const selectedMarques = getSelectedMarques();
    const builtCriteria = buildSearchCriteria(searchCriteria, selectedMarques);
    const searchOptions = prepareSearchOptions(builtCriteria);

    if (!searchOptions) {
      console.warn("searchOptions non valide");
      return null;
    }

    return {
      datasetName: activeList.file,
      searchOptions
    };
  };

  // Fonction principale de recherche dans la base de données (optimisée)
  const searchInDB = async () => {
    // Utiliser un flag pour éviter les appels multiples de showLoading(false)
    let loadingHandled = false;

    const ensureLoadingStopped = () => {
      if (!loadingHandled) {
        showLoading(false);
        loadingHandled = true;
      }
    };

    showLoading(true);

    try {
      // Validation préalable rapide
      if (!validateSearchPrerequisites()) {
        ensureLoadingStopped();
        return;
      }

      // Préparer les données de recherche
      const searchData = prepareSearchData();
      if (!searchData) {
        ensureLoadingStopped();
        return;
      }

      // Exécuter la recherche avec destructuring
      const { datasetName, searchOptions } = searchData;
      const result = await window.IndexedDBManager.getTopItemsFromDB(
        datasetName,
        showListItems,
        searchOptions
      );
      console.log("Résultat de la recherche:", result);
      if (!result) {
        console.warn("Résultat de recherche null ou undefined");
        ensureLoadingStopped();
        return;
      }

      // Afficher les résultats dans le tableau
      displaySearchResults(result);

      // Utiliser requestAnimationFrame pour optimiser la mise à jour des boutons
      requestAnimationFrame(() => {
        updateSortButtons();
      });

    } catch (error) {
      handleSearchError(error);
    } finally {
      ensureLoadingStopped();
    }
  };


function displayHE(activeDataset) {
  document.querySelector(SELECTORS.THERMOPOMPE_HE).style.display = "none";
  if(activeDataset === "proprio-maison") {
    document.querySelector(SELECTORS.THERMOPOMPE_HE).style.display = "block";
  }
}

// Fonction pour afficher/masquer les colonnes
function showHideColumn(className) {
  const elements = document.querySelectorAll(`.${className}`);

  if (elements.length === 0) {
    console.warn(`Aucun élément trouvé pour la classe: ${className}`);
    return;
  }

  elements.forEach(element => {
    element.style.display = "table-cell"; // Afficher la colonne
  });
}

function hideColumn(className) {
  const elements = document.querySelectorAll(`.${className}`);

  elements.forEach(element => {
    element.style.display = "none"; // Cacher la colonne
  });
}

const showLoading = (show) => {
    const elements = [document.querySelector(SELECTORS.RESULTS_CONTAINER)];

    if (show) {
      UIHelper.showGlobalLoading(true, labelList.search[lang]);
      UIHelper.setElementsDisabled(elements, true);
    } else {
      UIHelper.showGlobalLoading(false);
      UIHelper.setElementsDisabled(elements, false);
    }
};


// Fonction sécurisée pour ajouter des gestionnaires d'événements
const addSecureEventListener = (selector, event, callback) => {
  const element = document.querySelector(selector);
  if (element) {
    element.addEventListener(event, (e) => {
      try {
        callback(e);
      } catch (error) {
        console.error(`Erreur dans le gestionnaire d'événement pour ${selector}:`, error);
      }
    });
  } else {
    console.warn(`Élément non trouvé pour le sélecteur: ${selector}`);
  }
};

function ga4DataLayerPush(target) {
  let clickedElemVal = target.textContent.trim().replace(/\s+/g, " ");

  let ga4Element = {
    element_label: clickedElemVal,
    step_nb: "3",
    step_name: "Appliquer les filtres de recherche"
  };

  if (window.initTrackingGA4) {
    window.initTrackingGA4.sendDataToGA4(ga4Element);
  }
}

// Utilisation sécurisée des gestionnaires d'événements

// Flag pour savoir si une recherche est en attente de dataReady
let pendingSearch = false;

const setSelectors = () => {
  addSecureEventListener(SELECTORS.BUTTON_FILTRES, "click", function(e) {
    e.preventDefault(); // Empêcher le comportement par défaut

    const minmaxValidated = validationForm.validateMinMax();
    let formIsValid = [];
    listErrors = []; // Réinitialiser la liste des erreurs

    formIsValid.push(validationForm.marquesMaxLength().isValid);
    formIsValid.push(minmaxValidated.minmaxIsValid);

    const goForm = formIsValid.every(Boolean); // Tous les éléments doivent être true
    window.goForm = goForm; // Mettre à jour la variable globale

    resetAllFailField();
    hideDisplayWallErrors();

    displayFailMarques(validationForm.marquesMaxLength().isValid);
    displayFailField(minmaxValidated.itemsValidated);
    displayWallErrors();

    if(goForm) {
      showLoading(true);
      displayHE(activeList.name);
      resetPagination();

      // Si les données sont prêtes, lancer la recherche immédiatement
      if (window.IndexedDBManager?.isDataReady) {
        searchInDB();
      } else {
        // Sinon, marquer qu'une recherche est en attente
        console.log("Données pas encore prêtes, recherche en attente...");
        pendingSearch = true;
      }

      ga4DataLayerPush(e.target);
    }

    accordeonModule.handleAccordeonResize();
  });

  addSecureEventListener(SELECTORS.BUTTON_RESET, "click", function(e) {
    e.preventDefault(); // Empêcher le comportement par défaut
    resetAllFailField();
    resetAllFilters();
    hideDisplayWallErrors();
  });
}

const displayFailField = (el) => {
  el.forEach(item => {
    const field = item.element;
    if (field) {
      field.classList.add("js-range-container-errors");
      const statusMessageContainer = field.parentElement?.querySelector(".js-status-message");
      if (statusMessageContainer) {
        field.parentElement?.querySelectorAll(".js-input-unit").forEach(input => input.classList.add("error"));
        UIHelper.displayErrorMessage(item.errorMessage, statusMessageContainer);
      }
    }
  });
  listErrors.push(...el);
};

const displayFailMarques = (isValid) => {
  if (!isValid) {
    const marquesContainer = document.querySelector(SELECTORS.MARQUES_CONTAINER);
    const marquesInput = marquesContainer.querySelector(".js-input");
    marquesInput.classList.add("error");
    if (marquesContainer) {
      const statusMessageContainer = marquesContainer.parentElement?.querySelector(".js-status-message");
      if (statusMessageContainer) {
        const errorMessage = validationForm.marquesMaxLength().message;
        UIHelper.displayErrorMessage(errorMessage, statusMessageContainer);
      }
    }
    listErrors.push({
      element: marquesContainer,
      errorMessage: validationForm.marquesMaxLength().message
    });
  }
};


// Fonction optimisée pour afficher le mur d'erreurs
const displayWallErrors = () => {
  // Validation précoce avec early return
  if (!listErrors?.length) {
    return;
  }

  try {
    // Obtenir et valider les éléments du DOM
    const wallElements = getWallErrorElements();
    if (!wallElements) {
      return;
    }

    const { wall, wallList } = wallElements;

    // Vider la liste précédente une seule fois
    wallList.innerHTML = "";

    // Créer et ajouter les nouveaux éléments d'erreur
    createErrorItems(wallList);

    // Afficher et donner le focus au mur d'erreurs
    wall.style.display = "block";
    wall.focus();

  } catch (error) {
    console.error("Erreur lors de l'affichage du mur d'erreurs:", error);
  }
};

// Fonction pour valider et obtenir les éléments du mur d'erreurs
const getWallErrorElements = () => {
  const wall = document.querySelector(SELECTORS.WALL_OF_ERRORS);
  if (!wall) {
    console.warn("Wall of errors element not found");
    return null;
  }

  const wallContainer = wall.querySelector(".js-wall");
  const wallList = wallContainer?.querySelector(".js-wall-list");

  if (!wallList) {
    console.warn("Wall list element not found");
    return null;
  }

  return { wall, wallList };
};

// Fonction pour créer un lien d'erreur avec gestionnaire d'événement
const createErrorLink = (item) => {
  const link = document.createElement("a");
  link.href = "#";
  link.className = "hq-lien";
  link.textContent = item.errorMessage;

  // Optimiser le gestionnaire de clic avec une seule fonction
  link.addEventListener("click", (e) => {
    e.preventDefault();
    const targetInput = item.element?.querySelector('input[class*="_min"]') || item.element?.querySelector(".js-input-marque");
    if (targetInput) {
      targetInput.focus();
      targetInput.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  return link;
};

// Fonction pour créer les éléments d'erreur de manière optimisée
const createErrorItems = (wallList) => {
  // Utiliser DocumentFragment pour optimiser les manipulations DOM
  const fragment = document.createDocumentFragment();

  listErrors.forEach(item => {
    if (!item?.errorMessage) {
      console.warn("Error item missing required properties:", item);
      return;
    }

    const link = createErrorLink(item);
    const li = document.createElement("li");
    li.appendChild(link);
    fragment.appendChild(li);
  });

  document.querySelector(".js-wall-title").textContent = filtresLabels[lang].erreurs(listErrors.length);
  // Une seule manipulation DOM pour ajouter tous les éléments
  wallList.appendChild(fragment);
};



const hideDisplayWallErrors = () => {
  const wall = document.querySelector(SELECTORS.WALL_OF_ERRORS);
  if (wall) {
    wall.style.display = "none";
  }
};

// Fonction pour réinitialiser les erreurs d'un élément spécifique
const resetElementErrors = (element) => {
  if (!element) return;
  element.classList.remove("error");

  const parentElement = element.parentElement;
  if (!parentElement) return;

  const statusMessage = parentElement.querySelector(".js-status-message");
  if (statusMessage) {
    statusMessage.innerHTML = "";

    // Réinitialiser les classes d'erreur sur les inputs
    parentElement.querySelectorAll(".js-input-unit").forEach(input => {
      input.classList.remove("error");
    });
  }
};

// Fonction pour obtenir tous les éléments avec erreurs
const getAllErrorElements = () => {
  let errorFields = Array.from(document.querySelectorAll(".js-range-container-errors"));
  errorFields = [...document.querySelectorAll(".error")];
  const marquesContainer = document.querySelector(SELECTORS.MARQUES_CONTAINER);

  // Ajouter le conteneur des marques s'il existe
  if (marquesContainer) {
    errorFields.push(marquesContainer);
  }

  return errorFields;
};

// Fonction optimisée pour réinitialiser tous les champs d'erreur
const resetAllFailField = () => {
  try {
    // Obtenir tous les éléments avec des erreurs en une seule fois
    const allErrorElements = getAllErrorElements();
    const errorContainerFields = Array.from(document.querySelectorAll(".js-range-container-errors"));

    if (allErrorElements.length === 0) {
      listErrors = [];
      return;
    }

    if (errorContainerFields.length === 0) {
      return;
    }

    // Réinitialiser tous les éléments en une seule itération
    allErrorElements.forEach(element => {
      resetElementErrors(element);
    });

    errorContainerFields.forEach(element => {
      element.classList.remove("js-range-container-errors");
    });

    // Réinitialiser la liste des erreurs globale
    listErrors = [];

  } catch (error) {
    console.error("Erreur lors de la réinitialisation des champs d'erreur:", error);
    // Fallback: s'assurer que la liste des erreurs est vidée même en cas d'erreur
    listErrors = [];
  }
};

const resetAllFilters = () =>  {
  // Réinitialiser les champs de saisie de façon sécurisée
  const fieldsToReset = [
    SELECTORS.MODELE_EXTERNE,
    SELECTORS.MODELE_INTERNE,
    SELECTORS.FOURNAISE,
    SELECTORS.PUISSANCE_NOMINALE_MIN,
    SELECTORS.PUISSANCE_NOMINALE_MAX,
    SELECTORS.PUISSANCE_MOINS_8_MIN,
    SELECTORS.PUISSANCE_MOINS_8_MAX,
    SELECTORS.AIDE_FINANCIERE_MIN,
    SELECTORS.AIDE_FINANCIERE_MAX
  ];

  const checkboxToReset = [
    SELECTORS.CHECKBOX_THERMOPOMPE_HE,
    SELECTORS.CHECKBOX_PUISSANCE_NOMINALE,
    SELECTORS.CHECKBOX_PUISSANCE_MOINS_8,
    SELECTORS.CHECKBOX_ADMISSIBLE_BONIFICATION
  ];


  fieldsToReset.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      element.value = "";
    }
  });

  checkboxToReset.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      element.checked = false;
    }
  });

  // Réinitialiser la pagination
  resetPagination();

  // Reset Marques
  try {
    const marquesSelector = window.initMarquesSelector;
    if (marquesSelector) {
      marquesSelector.resetSelectedMarques();
    }
  } catch (error) {
    console.warn("Erreur lors de la réinitialisation des marques:", error);
  }

  // Réexécuter la recherche pour afficher tous les résultats
  //searchInDB();

  //Hide the columns
  hideColumn(`col-${helpers.correlateFields("puissance_moins_8",g_listOrigin)}`);
  hideColumn(`col-${helpers.correlateFields("puissance_nominale",g_listOrigin)}`);

  //Hide the table container
  document.querySelector(SELECTORS.RESULTS_CONTAINER).innerHTML = "";
}

  // Configuration CSV (mécanique générique déplacée vers modules/csvExporter.js)
  const CSV_CONFIG = {
    separator: ";",
    filePrefix: "thermopompes_efficaces_"
  };

  // Fonction optimisée pour générer les en-têtes CSV
  const generateCsvHeaders = (fieldsToShow) => {
    return fieldsToShow
      .filter(field => field && field !== "")
      .map(fieldKey => {
        console.log("Processing fieldKey:", fieldKey);
        const conditionKey = (activeList.name !== "entrepreneur-plex" && (fieldKey === "aide_financiere_a" || fieldKey === "TTG_AF_Maison1" || fieldKey === "TTG_Ext2"));
        const field = (conditionKey) ? headingFieldsLabel.aide_financiere : (g_listOrigin === "es" ? headingFieldsLabel_es : headingFieldsLabel)[fieldKey];
        return field?.label?.[lang] || fieldKey;
      });

  };


  // Fonction optimisée pour traiter une ligne de données
  const processDataRow = (item, fieldsToShow, separator) => {
    return fieldsToShow.map(fieldKey => {
      if (!fieldKey) return "";

      let value = item[fieldKey] || "";

      // Formater la valeur une seule fois
      value = formatCellValue(fieldKey, value);

      // Échapper la valeur si nécessaire
      return window.csvExporter.escapeValue(value, separator);
    });
  };

  // Fonction principale optimisée pour exporter les données en CSV
  const exportToCSV = (data) => {
    // Validation précoce avec messages d'erreur améliorés
    if (!Array.isArray(data)) {
      console.warn("Les données doivent être un tableau");
      return false;
    }

    if (data.length === 0) {
      console.warn("Aucune donnée à exporter");
      return false;
    }

    try {
      const { separator, filePrefix } = CSV_CONFIG;

      // Obtenir et valider les champs à afficher
      const fieldsToShow = getFieldsToShow()?.filter(field => field && field !== "");
      if (!fieldsToShow?.length) {
        console.warn("Aucun champ valide à exporter");
        return false;
      }

      console.log("Fields to show:", fieldsToShow);

      // Générer les en-têtes de manière optimisée
      const headers = generateCsvHeaders(fieldsToShow);
      if (!headers.length) {
        console.warn("Impossible de générer les en-têtes CSV");
        return false;
      }

      // Utiliser un tableau pour construire le CSV (plus efficace que la concaténation de strings)
      const csvLines = [headers.join(separator)];

      // Traiter les données par batch pour éviter les problèmes de mémoire
      const batchSize = 1000;
      for (let i = 0; i < data.length; i += batchSize) {
        const batch = data.slice(i, i + batchSize);

        const batchLines = batch.map(item => {
          const row = processDataRow(item, fieldsToShow, separator);
          return row.join(separator);
        });

        csvLines.push(...batchLines);
      }

      // Joindre toutes les lignes en une seule fois
      const csvContent = csvLines.join("\n");

      // Générer le nom de fichier et télécharger
      const fileName = window.csvExporter.generateFileName(filePrefix);
      const downloadSuccess = window.csvExporter.download(csvContent, fileName);

      if (downloadSuccess) {

        // Annoncer le succès aux lecteurs d'écran si la fonction est disponible
        if (typeof announceToScreenReader === "function") {
          const message = `Export terminé: ${data.length} résultats exportés`;
          announceToScreenReader(message);
        }

        return true;
      }

      return false;

    } catch (error) {
      console.error("Erreur lors de l'export CSV:", error);

      // Annoncer l'erreur aux lecteurs d'écran si la fonction est disponible
      if (typeof announceToScreenReader === "function") {
        announceToScreenReader("Erreur lors de l'export CSV");
      }

      return false;
    }
  };

  // Blocage des caractères invalides dans les inputs numériques (voir modules/numericInputGuard.js)
  window.numericInputGuard.init();

  //Init
  init();

  // Exposer les fonctions
  return {
     displaySearchResults,
     createPaginationControls,
     resetPagination,
     searchInDB,
     setSelectors,
     handleColumnSort,
     updateSortButtons,
     init,
     getPaginationState: () => paginationState,
     setPaginationPage: (page) => { paginationState.currentPage = page; },
     getSortState: () => sortState,
     setSortState: (field, direction) => {
       sortState.field = field;
       sortState.direction = direction;
     },
     resetAllFilters,
     exportToCSV
  };

}

window.tableauResultats = tableauResultats();
export default window.tableauResultats;
